import { SURFACE_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { BODY_SM_SM_MEDIUM_STYLES, HEADING_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const EmptyWrapper = styled.div<{ $bgColor?: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${({ $bgColor }) => $bgColor || SURFACE_COLORS.information};
    padding: 48px 0 40px 0;
    border-radius: 8px;
    width: 100%;
`;

export const EmptyTitleWrapper = styled.div`
    color: ${TEXT_COLORS.heading};
    ${HEADING_SM_STYLES};
    text-align: center;
    padding-top: 24px;
`;

export const EmptyDescWrapper = styled.div`
    color: ${TEXT_COLORS.body};
    ${BODY_SM_SM_MEDIUM_STYLES};
    text-align: center;
    padding-bottom: 24px;
`;
